import type { IContainer } from '@monofe/di';
import { injectOrBuildContainer } from '@monofe/di';
import TYPES from '../util/types';
import type { LANGUAGE_CODE } from './translationStorage';

export enum IBrowserPlatform {
    Unknown = 0,
    MobileiOS = 1,
    MobileAndroid = 2,
}

export interface IBrowser {
    platform: IBrowserPlatform;
    isMobile: boolean;
    isInstalled: boolean;
    language: LANGUAGE_CODE;
}

export function injectBrowser(container: IContainer = injectOrBuildContainer()): IBrowser {
    return container.get<IBrowser>(TYPES.IBrowser);
}

export function bindBrowser(val: IBrowser, container: IContainer = injectOrBuildContainer()): void {
    container.bind<IBrowser>(TYPES.IBrowser, val);
}

export function unbindBrowser(container: IContainer = injectOrBuildContainer()): void {
    container.remove(TYPES.IBrowser);
}
